(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-quiz"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('product-quiz')) return;
  class ProductQuiz extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.answers = [null, null, null];
      this.screen = this.dataset.intro === 'true' ? 'intro' : 'q1';
      this.availableKeys = Array.from(this.querySelectorAll('[data-result]'), node => node.dataset.result);
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-start')) this.show('q1');
        else if (button.hasAttribute('data-answer')) this.choose(button);
        else if (button.hasAttribute('data-back')) this.back();
        else if (button.hasAttribute('data-retake')) this.reset();
      }, { signal: this.controller.signal });
      this.querySelectorAll('.main-product__error').forEach(node => {
        node.setAttribute('role', 'alert');
        node.setAttribute('aria-live', 'polite');
      });
      this.videoVisible = !('IntersectionObserver' in window);
      if ('IntersectionObserver' in window) {
        this.videoObserver = new IntersectionObserver(entries => {
          this.videoVisible = entries.some(entry => entry.isIntersecting);
          this.syncVideo();
        });
        this.querySelectorAll('.pq__video').forEach(video => this.videoObserver.observe(video));
      }
      this.show(this.screen, false);
    }
    disconnectedCallback() {
      clearTimeout(this.advanceTimer);
      this.videoObserver?.disconnect();
      this.querySelectorAll('.pq__video').forEach(video => video.pause());
      this.controller?.abort();
      this.controller = null;
    }
    show(screen, focus = true) {
      clearTimeout(this.advanceTimer);
      this.busy = false;
      const leavingIntro = this.screen === 'intro' && screen !== 'intro';
      this.screen = screen;
      this.syncVideo();
      this.querySelectorAll('[data-screen]').forEach(node => { node.hidden = node.dataset.screen !== screen; });
      this.querySelectorAll('[data-answer]').forEach(button => {
        button.disabled = !this.availableKeys.length;
        button.setAttribute('aria-pressed', String(this.answers[Number(button.dataset.question) - 1]?.answer === button.dataset.answer));
      });
      if (focus) this.querySelector(`[data-screen="${screen}"] [data-focus]`)?.focus({ preventScroll: !leavingIntro });
    }
    syncVideo() {
      this.querySelectorAll('.pq__video').forEach(video => {
        if (this.screen === 'intro' && this.videoVisible && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.muted = true;
          video.play().catch(() => {});
        } else video.pause();
      });
    }
    choose(button) {
      if (this.busy || !this.availableKeys.length) return;
      const index = Number(button.dataset.question) - 1;
      if (this.screen !== `q${index + 1}`) return;
      const key = this.availableKeys.includes(button.dataset.mapping) ? button.dataset.mapping : this.availableKeys[0];
      this.answers[index] = { key, answer: button.dataset.answer };
      this.answers.fill(null, index + 1);
      this.busy = true;
      this.querySelectorAll(`[data-question="${index + 1}"]`).forEach(answer => {
        answer.setAttribute('aria-pressed', String(answer === button));
        answer.disabled = true;
      });
      const delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 220;
      this.advanceTimer = setTimeout(() => {
        if (index < 2) this.show(`q${index + 2}`);
        else this.result();
      }, delay);
    }
    winner() {
      const scores = Object.fromEntries(this.availableKeys.map(key => [key, 0]));
      this.answers.forEach(answer => { if (answer) scores[answer.key] += 1; });
      const highest = Math.max(...Object.values(scores));
      return [...this.answers].reverse().find(answer => answer && scores[answer.key] === highest)?.key || this.availableKeys[0];
    }
    result() {
      if (this.answers.some(answer => !answer)) return;
      const winner = this.winner();
      this.querySelectorAll('[data-result]').forEach(node => { node.hidden = node.dataset.result !== winner; });
      this.show('result');
    }
    back() {
      const question = Number(this.screen.slice(1));
      if (!Number.isFinite(question)) return;
      this.show(question > 1 ? `q${question - 1}` : (this.dataset.intro === 'true' ? 'intro' : 'q1'));
    }
    reset() {
      this.answers = [null, null, null];
      this.querySelectorAll('[data-result]').forEach(node => { node.hidden = true; });
      this.show(this.dataset.intro === 'true' ? 'intro' : 'q1');
    }
  }
  customElements.define('product-quiz', ProductQuiz);
})();

  } catch(e) { console.error(e); }
})();
})();
